import { gql } from '@apollo/client';

export const PROPERTY_FREETEXT_FRAGMENT = gql`
  fragment PropertyFreetext on Property {
    freetext {
      list {
        all {
          heading
          html
        }
        extra {
          heading
          text
        }
      }
    }
  }
`;
